import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class RoleService {

    private static getAllRolesUrl: string = '/api/roles/getAllRoles';

    constructor(
        private http: HttpClient
    ) { }

    public getAllRoles(): Observable<any> { 
        return this.http.get<any>(RoleService.getAllRolesUrl);
    }
};


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/role/role.service.ts